import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {
    KnowledgeData,
    KnowledgeDraft,
    KnowledgeItem,
    KnowledgeSection,
} from "../models/knowledge.models";

export const KnowledgeActions = createActionGroup({
    source: "Knowledge Base",
    events: {
        "Page Opened": emptyProps(),
        "Data Loaded": props<KnowledgeData>(),
        "Data Load Failed": emptyProps(),
        "Section Changed": props<{ section: KnowledgeSection }>(),
        "Query Changed": props<{ query: string }>(),
        "Save Requested": props<{
            section: KnowledgeSection;
            draft: KnowledgeDraft;
            current?: KnowledgeItem;
        }>(),
        "Save Succeeded": props<{ item: KnowledgeItem }>(),
        "Delete Requested": props<{ item: KnowledgeItem }>(),
        "Delete Succeeded": props<{ item: KnowledgeItem }>(),
        "Status Change Requested": props<{ item: KnowledgeItem }>(),
        "Status Change Succeeded": props<{ item: KnowledgeItem }>(),
        "Mutation Failed": emptyProps(),
        "Mutation Status Cleared": emptyProps(),
    },
});
